import { ECoworkingOfferType } from '../../../../packages/api-models/common/json_query';
import { ISelectOption } from 'shared/types/filters';

export const WORKPLACE_TYPE_OPTIONS: ISelectOption[] = [
  {
    label: 'Отдельное место',
    subtitle: 'Личный стол, который никто не займёт',
    value: ECoworkingOfferType.FixedWorkSpace,
  },
  {
    label: 'Свободная посадка',
    subtitle: 'Можно занять любое свободное место',
    value: ECoworkingOfferType.FreeWorkSpace,
  },
];
